export default __webpack_public_path__ + "static/media/download-app.a2625ddf.svg";